(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Dispositivo_osDeleteController',Dispositivo_osDeleteController);

    Dispositivo_osDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dispositivo_os'];

    function Dispositivo_osDeleteController($uibModalInstance, entity, Dispositivo_os) {
        var vm = this;

        vm.dispositivo_os = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dispositivo_os.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
